import firebase from "firebase/app";
import "firebase/firestore";

let firebaseApp = null;
let db = null;

export const initialiseFirebase = (config) => {
    firebaseApp = firebase.initializeApp(config);
    db = firebaseApp.firestore();
}

export const getDb = () => {
    return db;
}
